<template>
  <keep-alive>
    <router-view v-if="!loading"></router-view>
  </keep-alive>
</template>

<script>
import CacheService from "./service/catch";
import { getUrlString, replaceUrl } from "./utils/util";
import TokenService from "./service/token";
import request from "@/plugins/axios";
import { adminFunc } from "@/router/funcKey.js";
export default {
  name: "app",
  data() {
    return {
      compId: 0,
      isFirst: true,
      loading: true, // 先获取token再渲染首页，解决首页接口401
    };
  },
  created() {
    const state = CacheService.get("state");
    if (state) {
      this.$store.replaceState(state);
    }
    window.addEventListener("beforeunload", () => {
      CacheService.set("state", this.$store.state, "1");
    });
    this.compId = getUrlString("compId");
    const token = TokenService.get();
    if (!token) {
      if (this.compId) {
        this.getFirstSingleSignOn(); //检查是否是第一次登录，是第一次同步数据
      } else {
        top.location = this.$cloudUrl;
      }
    } else {
      const hasPower = this.hasPower();
      if (hasPower) this.loading = false;
    }
  },
  methods: {
    //是否第一次登录
    getFirstSingleSignOn() {
      this.loading = true;
      this.axios.get(`/Crm/User/FirstSingleSignOn?compId=${this.compId}`).then((res) => {
        if (!res) {
          if (this.isFirst) {
            this.getDataHandle();
            this.isFirst = false;
          }
          setTimeout(() => {
            this.$message.warning("数据正在进行同步，请稍后...");
            this.getFirstSingleSignOn();
          }, 5000);
        } else {
          this.getToken();
        }
      });
    },
    //同步数据
    getDataHandle() {
      this.isFirst = true;
      this.axios.get(`/Crm/Data/DataHandle?compId=${this.compId}`).then((res) => {
        if (!res) {
          this.$message.success("同步失败");
        }
      });
    },
    //获取token
    getToken() {
      var ticket = getUrlString("ticket");
      if (ticket) {
        this.axios.get(`/Crm/User/SingleSignOn?ticket=${ticket}&loginDevice=1`).then((res) => {
          if (!TokenService.get()) {
            let obj = {
              refreshToken: res.loginToken.refreshToken,
              accessToken: res.loginToken.accessToken,
              refreshTokenExpired: res.loginToken.refreshTokenExpired,
            };
            TokenService.set(obj);
            CacheService.set("user", res, "1");
            this.$store.commit("initUser", res);

            if (res.roleList.some((r) => r.id == 1)) {
              this.$store.commit("initFuncKey", adminFunc);
            } else {
              this.$store.commit("initFuncKey", res.funcKey || []);
              let hasPower = this.hasPower();
              if (!hasPower) throw new Error("您没有该项目权限，请联系管理员"); // 阻断后续代码
            }
            this.loading = false;
            if (process.env.NODE_ENV === "production") {
              history.replaceState("", "", window.location.href.replace(replaceUrl("ticket"), ""));
              history.replaceState("", "", window.location.href.replace(replaceUrl("compId"), ""));
            }
          }
          request.defaults.headers.common.Authorization = `Bearer ${res.loginToken.accessToken}`;
        });
      } else {
        this.loading = false;
      }
    },
    // 是否有项目权限
    hasPower() {
      let hasFunckey = this.$store.state.myFuncKey && this.$store.state.myFuncKey.length;
      if (!hasFunckey) {
        this.$alert("您没有该项目权限，请联系管理员", "提示", {
          confirmButtonText: "确定",
          showClose: false,
          callback: (action) => {
            window.close();
          },
        });
        TokenService.remove();
      }
      return hasFunckey;
    },
  },
};
</script>
